import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
export const USER_TOKEN_KEY = "eterea_user_token";

api.interceptors.request.use((config) => {
  const pw = localStorage.getItem("eterea_admin_pw");
  const url = config.url || "";
  if (pw && url.includes("/admin")) {
    config.headers["X-Admin-Password"] = pw;
  }
  const userToken = localStorage.getItem(USER_TOKEN_KEY);
  if (userToken && !url.includes("/admin")) {
    config.headers["Authorization"] = `Bearer ${userToken}`;
  }
  return config;
});

export const errMsg = (e, fallback = "Algo salió mal, inténtalo de nuevo") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};

// Spanish zodiac + planets
// Spanish zodiac + planets (variation selector \uFE0E forces text presentation, not emoji)
export const ZODIAC_GLYPHS = {
  Aries: "♈\uFE0E", Taurus: "♉\uFE0E", Gemini: "♊\uFE0E", Cancer: "♋\uFE0E",
  Leo: "♌\uFE0E", Virgo: "♍\uFE0E", Libra: "♎\uFE0E", Scorpio: "♏\uFE0E",
  Sagittarius: "♐\uFE0E", Capricorn: "♑\uFE0E", Aquarius: "♒\uFE0E", Pisces: "♓\uFE0E",
};

export const PLANET_GLYPHS = {
  Sun: "☉\uFE0E", Moon: "☽\uFE0E", Mercury: "☿\uFE0E", Venus: "♀\uFE0E", Mars: "♂\uFE0E",
  Jupiter: "♃\uFE0E", Saturn: "♄\uFE0E", Uranus: "♅\uFE0E", Neptune: "♆\uFE0E", Pluto: "♇\uFE0E",
  Chiron: "⚷\uFE0E", Lilith: "⚸\uFE0E",
};

export const SIGN_EN_ES = {
  Aries: "Aries", Taurus: "Tauro", Gemini: "Géminis", Cancer: "Cáncer",
  Leo: "Leo", Virgo: "Virgo", Libra: "Libra", Scorpio: "Escorpio",
  Sagittarius: "Sagitario", Capricorn: "Capricornio",
  Aquarius: "Acuario", Pisces: "Piscis",
};

export const PLANET_EN_ES = {
  Sun: "Sol", Moon: "Luna", Mercury: "Mercurio", Venus: "Venus",
  Mars: "Marte", Jupiter: "Júpiter", Saturn: "Saturno",
  Uranus: "Urano", Neptune: "Neptuno", Pluto: "Plutón",
  Chiron: "Quirón", Lilith: "Lilith",
};

export const ASPECT_EN_ES = {
  Conjunction: "Conjunción", Opposition: "Oposición",
  Trine: "Trígono", Square: "Cuadratura", Sextile: "Sextil", Quincunx: "Quincuncio",
};

export const TARGET_ES = {
  ...PLANET_EN_ES, Ascendant: "Ascendente", Descendant: "Descendente", Midheaven: "Medio Cielo", ImumCoeli: "Fondo del Cielo",
};
